.legend {
  border-top: 1px solid var(--rule);
}

.summary {
  display: flex;
  align-items: center;
  min-height: 44px;
  cursor: pointer;
  list-style: none;
}

.summary::-webkit-details-marker {
  display: none;
}

.summary::after {
  content: "";
  width: 7px;
  height: 7px;
  margin-left: auto;
  border-right: 1.5px solid var(--ink-muted);
  border-bottom: 1.5px solid var(--ink-muted);
  transform: rotate(-45deg);
  transition: transform var(--duration) var(--ease-out);
}

.legend[open] .summary::after {
  transform: rotate(45deg);
}

.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: var(--space-2) var(--space-3);
  padding-bottom: var(--space-3);
}

.note {
  font-size: var(--text-sm);
  color: var(--ink-subtle);
  border-left: 2px solid var(--accent);
  padding-left: var(--space-3);
  margin-bottom: var(--space-3);
  max-width: 60ch;
}
